import { Component, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Constants } from 'src/app/_helpers/constant';
import { SignupService } from 'src/app/core/services/signup.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmedValidators } from '../../_helpers/confirmed.validators';
import { OtpVerifyService } from 'src/app/core/services/otp-verify.service';
import { LoginService } from 'src/app/core/services/login.service';
import { RoleSignupService } from 'src/app/core/services/role-signup.service';
import { ToastNotificationService } from 'src/app/core/services/toast-notification.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as intlTelInput from 'intl-tel-input';
import { LedgerServiceService } from 'src/app/core/services/ledger-service.service';
import { CommonService } from 'src/app/core/services/common.service';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  defaultLedgerData = {
    "userId": "{{userId}}",
    "data": [
      {
        "userCaseId": 1,
        "debit_gl": "1.1.8",
        "credit_gl": "1.1.2"
      },
      {
        "userCaseId": 2,
        "debit_gl": "1.1.7",
        "credit_gl": "1.1.3"
      },
      {
        "userCaseId": 3,
        "debit_gl": "1.1.1",
        "credit_gl": "1.1.4"
      },
      {
        "userCaseId": 4,
        "debit_gl": "2.1.1",
        "credit_gl": "1.1.6"
      },
      {
        "userCaseId": 7,
        "debit_gl": "2.1.1",
        "credit_gl": "1.1.3"
      },
      {
        "userCaseId": 8,
        "debit_gl": "2.1.1",
        "credit_gl": "1.1.6"
      },
      {
        "userCaseId": 9,
        "debit_gl": "2.1.2",
        "credit_gl": "1.1.7"
      }

    ]
  }
  @Input() afterRegister: boolean = false;
  @Output() CustLogintoggle: boolean;
  public user: number;
  public Custtoggle: boolean;
  public userName: String = "Client";
  public registerForm: FormGroup;
  public resend: any;
  // public otpData:FormGroup;
  public customerRegisterForm: FormGroup;
  public role: number = 1;
  public showClientOtp: boolean = false;
  public showCustomerOtp: boolean = false;
  public submitted: boolean = false;
  public successful: boolean = false;
  public otpClientData: FormGroup;
  public otpCustomerData: FormGroup;
  public showAlert: boolean;
  public hide: boolean = true;
  public hide2: boolean = true;
  interval: NodeJS.Timeout;
  timeLeft: number;
  messageSuccess: boolean;
  otpErrorMessage: boolean = false;
  public input: any;
  public AllCountry: any;
  public CountryList: any;
  public countryID: string = "91";
  public filteredOptions: Observable<any[]>;
  public errorMesage = '';
  public showPassword: boolean = false;
  countryCode: string;
  phoneNumber: string;
  // CustLogintoggle: boolean;
  constructor(public fb: FormBuilder,
    public roleSignupService: RoleSignupService,
    public signupService: SignupService,
    public loginService: LoginService,
    private toastService: ToastNotificationService,
    public router: Router,
    public route: ActivatedRoute,
    public otpVerify: OtpVerifyService,
    public commonService: CommonService,
    private ledgerService: LedgerServiceService,
    private titleCasePipe: TitleCasePipe) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.Custtoggle = params['Custtoggle'] === 'true';
    });

    this.getAllCountry();
    //form for client registartion
      this.registerForm = this.fb.group({
        firstName: ["", [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
        // lastName: ["", [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
        email: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$")]],
        mobile: ["", [Validators.pattern("[0-9]{10}")]],
        password: ["", [Validators.required]],
        // ConfirmPassword: ["", [Validators.required]],
        acceptTerms: ["", [Validators.required]],
        countryId: ["+91", [Validators.required]],
        industryType: [null, [Validators.required]]
      }, {
        validator: ConfirmedValidators('password', 'password')
      });

    //form for customer registration
    // if (this.isArabic) {
      this.customerRegisterForm = this.fb.group({

        firstName: ["", [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
        // lastName: ["", [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
        // email:["",[Validators.required,Validators.pattern("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$")]],
        mobile: ["", [Validators.pattern("[0-9]{10}")]],
        countryId: ["+91", [Validators.required]],

        acceptTerms: ["", [Validators.required]],
      });
    // } else {
    //   this.customerRegisterForm = this.fb.group({

    //     firstName: ["", [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
    //     // lastName: ["", [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
    //     // email:["",[Validators.required,Validators.pattern("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$")]],
    //     mobile: ["", [Validators.required, Validators.pattern("[0-9]{10}")]],
    //     countryId: [this.isArabic ? "+971" : "+91", [Validators.required]],

    //     acceptTerms: ["", [Validators.required]],
    //   });
    // }

    //form for client and customer otp

    this.otpClientData = this.fb.group({
      emailotp: ["", [Validators.required, Validators.email]],
      // mobileotp:["",[Validators.required,Validators.pattern("[0-9]{10}")]],
    });

    // if (this.isArabic) {
    //   this.otpCustomerData = this.fb.group({
    //     //emailotp:  [ "",[Validators.required,Validators.pattern("[0-9]{10}")]],
    //     mobileotp: ["", [Validators.required, Validators.pattern("[0-9]{9}")]],

    //   });
    // } else {
      this.otpCustomerData = this.fb.group({
        //emailotp:  [ "",[Validators.required,Validators.pattern("[0-9]{10}")]],
        mobileotp: ["", [Validators.required, Validators.pattern("[0-9]{10}")]],

      });
    // }

    this.filteredOptions = this.registerForm.get('countryId').valueChanges.pipe(
      startWith(''),
      map(value => {
        if (this.CountryList) {
          const name = typeof value === 'string' ? value : value;
          return name ? this._filter(name) : this.CountryList.slice();
        }
      }),
    );
  }

  onCustomerClick() {
    // this.router.navigate(['auth/role-selection']);
    this.CustLogintoggle = false;
    this.router.navigate(['auth/role-selection']);
  }

  onRetailerClick() {
    // this.router.navigate(['auth/role-selection']);
    this.CustLogintoggle = true;
    this.router.navigate(['auth/role-selection']);
  }

  displayFn(user?: any): string | undefined {
    return user ? user : '';
  }
  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.CountryList.filter(option => option.countryName.toLowerCase().includes(filterValue));
  }
  getAllCountry() {
    this.signupService.getAllCountryClient({}).then((res) => {
      this.AllCountry = res;
      this.CountryList = this.AllCountry.data;
    })
  }
  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  //to show/hide password
  toggleShow() {
    this.hide = !this.hide;
    //  this.input.type = this.hide ? 'text' : 'password';
  }
  toggleShow2() {
    this.hide2 = !this.hide2;
    //  this.input.type = this.hide ? 'text' : 'password';
  }
  // controls for client validation
  get f() {
    return this.registerForm.controls;
  }
  // controls for customer validation
  get c() {
    return this.customerRegisterForm.controls;
  }
  //control client and customer registetration UI
  show(id) {
    if (id === 1) {
      this.user = Constants.USER.CLIENT;
      this.Custtoggle = false;
      this.showAlert = false;
      this.registerForm.clearValidators();
      //this.disabled = false;
      this.userName = "Client";
    }
    else if (id === 2) {
      this.user = Constants.USER.CUSTOMER;
      this.Custtoggle = true;
      this.userName = "Customer";
      this.showAlert = false;
      this.customerRegisterForm.clearValidators();
    }
  }
  //client register
  clientRegister() {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }

    let req = {
      "email": this.registerForm.controls.email.value,
      "password": this.registerForm.controls.password.value,
      // "countryId": this.countryID, //"228",//this.countryID,
      "firstName": this.registerForm.controls.firstName.value,
      "mobile": this.registerForm.controls.mobile.value,
      countryId: '102',
      industryType: this.registerForm.controls.industryType.value
      // countryId: '102'
      // "lastName" :this.registerForm.controls.lastName.value,
    }

    if ( this.registerForm.value.countryId == '+971') {
      req.countryId = '228'
    }

    this.signupService.registerClientUsers(req).then((data) => {
      if (data.success) {
        // Create a copy of the defaultLedgerData object
        const requestData = { ...this.defaultLedgerData };

        // Set the userId property in the requestData object
        requestData.userId = data.data.id;
        // this.ledgerService.assignLedgersv2(requestData, data.data.id).then((res) => {
        // })
        this.showClientOtp = true;
        this.successful = true;
      }
    },
      (error) => {
        this.errorMesage = error.error.error_message;
        this.toastService.toastMsg({
          title : 'Error',
          content : this.titleCasePipe.transform(error.error.error_message)
        })
        this.showAlert = true;
      })
      .catch(error => {
        this.showAlert = true;
        console.log("sdsd https://web.iceipts.com/", this.showAlert)
      })
  }
  //Customer Register
  customerRegister() {
    this.submitted = true;
    console.log("this.customerRegisterForm",this.customerRegisterForm)
    if (this.customerRegisterForm.invalid) {

      return;
    }
    this.signupService.registerCustomerUsers(this.customerRegisterForm.value).then((data) => {
      if (data) {
        let d = {
          mobile: this.customerRegisterForm.controls.mobile.value,
        }
        //this.loginService.postSendOtp(d).then((res)=>{
        this.successful = true;
        this.showCustomerOtp = true;
        this.afterRegister = true;
      }
    },
      (error) => {
        this.errorMesage = error.error.error_message;
        this.toastService.toastMsg({
          title : 'Error',
          content : this.titleCasePipe.transform(error.error.error_message)
        })
        this.showAlert = true;
      }).catch(error => {
        this.errorMesage = error.error.error_message;
        this.showAlert = true;
      })
  }
  //verify client Otp
  verifyClientOtp() {
    const data = {
      email: this.registerForm.controls.email.value,
      emailotp: this.otpClientData.controls.emailotp.value,
      //type:"0",
      //mobileotp:this.otpData.controls.mobileotp.value,
    }

    this.otpVerify.verifyCLientOtp(data).then((data) => {
      this.router.navigate(['/auth/role-selection'])
    }, (err) => {
      this.toastService.toastMsg({
        title: "Error",
        content: "Enter Valid OTP",
      });
    })
  }
  customerResendOtp() {
    let d = {
      mobile: this.customerRegisterForm.controls.mobile.value,
    }
    this.loginService.postSendOtp(d).then((res) => {
      this.resend = res
    })
    this.messageSuccess = true;
    setTimeout(() => {                           //<<<---using ()=> syntax
      this.messageSuccess = false;
    }, 120000);
  }
  clientResendOtp() {
    let d = {
      email: this.registerForm.controls.email.value,
    }
    this.roleSignupService.sendRoleUsersOtp(d).then((res) => {
      this.resend = res
    })
    this.messageSuccess = true;
    setTimeout(() => {                           //<<<---using ()=> syntax
      this.messageSuccess = false;
    }, 60000);
  }
  //Verify customer otp
  verifyCustomerOtp() {
    this.showCustomerOtp = true;
    let d = {
      mobile: this.customerRegisterForm.controls.mobile.value,
      //type:"1",
      mobileotp: this.otpCustomerData.controls.mobileotp.value,
    }
    this.router.navigate(['/auth/role-selection'])
    // this.otpVerify.verifyCustomertOtp(d).then((data) => {
    //   this.router.navigate(['/auth/login'])
    // }, (err) => {
    //   if (err) {
    //     this.otpErrorMessage = true
    //   }
    // })
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  setCountryId(option) {
    let optionid = option.id
    this.countryID = optionid.toString();
  }
  getCountryByname(e) {
    let serachkey = e.target.value;
    if (serachkey !== 0) {
      this.signupService.SearchCountryByNameId({}, serachkey).then((res) => {
        this.AllCountry = res;
        this.CountryList = this.AllCountry.data;
      })
    }
  }

  /**
   * Customer Resend OTP
   */
  customerLoginResendOtp() {
    // this.spinner.show();
    // this.isLoginBtn= true;
    let d = {
      mobile: this.customerRegisterForm.controls.mobile.value,
    }
    this.loginService.postSendOtp(d).then((res) => {
      // this.spinner.hide();
      // this.isLoginBtn = false;
      this.resend = res
    }, (err) => {
      // this.isLoginBtn = false;
    })
    this.messageSuccess = true;
    setTimeout(() => {                           //<<<---using ()=> syntax
      this.messageSuccess = false;
    }, 120000);
  }
}
